export const projectsData = [
  {
    id: "neogrowth",
    title: "NeoGrowth: Fenton 2025 & 2013",
    category: "iOS App",
    date: "2025",
    summary:
      "iOS clinical application based on the new Fenton 2025 & 2013 growth charts. Reached 1.5k+ downloads on the App Store.",
    tags: ["iOS", "Swift"],
    githubUrl: "https://github.com/rebeccaschou/neogrowth",
    paperUrl: null,
    noLinksText: null,
    overview:
      "NeoGrowth provides neonatologists and pediatric clinicians with a fast, offline-first tool for calculating growth percentiles and z-scores in premature infants using updated Fenton growth metrics.",
    keyContributions: [
      "Designed an intuitive and customizable UI optimized for fast data entry in high-stress clinical environments.",
      "Implemented pediatric growth calculation engines to calculate and flag projected growth.",
      "Accumulated over 1,500 downloads across pediatric healthcare units."
    ],
    technologies: ["Swift", "SwiftUI", "XCode"]
  },
  {
    id: "peditools",
    title: "PediTools: Fenton 2013",
    category: "iOS App",
    date: "2018 – 2019",
    summary:
      "iOS clinical application based on the Fenton 2013 growth charts. Reached 13k+ downloads on the App Store.",
    tags: ["iOS", "Swift"],
    githubUrl: null,
    paperUrl: null,
    noLinksText: "Source code available upon request.",
    overview:
      "PediTools: Fenton 2013 provides neonatologists and pediatric clinicians with a fast, offline-first tool for calculating growth percentiles and z-scores in premature infants using updated Fenton growth metrics.",
    keyContributions: [
      "Implemented pediatric growth calculation engines to calculate and flag projected growth.",
      "Accumulated over 13,000 downloads across pediatric healthcare units in over 60 countries."
    ],
    technologies: ["Swift", "XCode"]
  }
];